import React, { useState } from "react";
import { BsWhatsapp } from "react-icons/bs";
import { AiFillCaretDown, AiOutlinePhone } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";

  const Navbar = () => {
    const [activeIndex, setActiveIndex] = useState(null);

        const Logo = "https://izbassetsmain.blob.core.windows.net/izbwebassets/logo.png";
        const Phone = "https://izbassetsmain.blob.core.windows.net/izbwebassets/PhoneCall.png";
        const PlayStore = "https://izbassetsmain.blob.core.windows.net/izbwebassets/PlayStore.png";
        const apple = "https://izbassetsmain.blob.core.windows.net/izbwebassets/apple.png";
        const notification = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Bell_red.svg";

        const [menuOpen, setMenuOpen] = useState(false);

        const toggleMenu = () => {
          setMenuOpen(!menuOpen);
          document.body.classList.toggle("locked", menuOpen);
        };
      
        const closeMenu = () => {
          setMenuOpen(false);
          document.body.classList.remove("locked");
        };
 

  return (
    <>
      <header className="main-header main-header-style1">
        {/*Start Main Header Style1 Top*/}
        <div className="main-header-style1-top py-2">
          <div className="container-fluid">
            <div className="outer-box justify-content-between">
            
              <div className="main-header-style1-top__left">
                <div
                  className="looking-banking-box"
                  style={{ paddingLeft: "40px" }}
                >
                  <Link to="/">
                    <img src={Logo} width={300} />
                  </Link>
                </div>
                {/* <div className="ms-4 ps-4">
                  <div className="input-group">
                    <div className="form-outline">
                      <input
                        style={{
                          backgroundColor: "#F0F0F0",
                          borderRadius: "21px",
                          color:"#000!important"
                        }}
                        id="search-input"
                        type="search"
                        placeholder="Search"
                        className="form-control pe-2"
                      />
                    </div>
                  </div>
                </div> */}
              </div>

              <div className="main-header-style1-top__right ">
                <div className="header-menu-style1">
                  <div className="btn-box">
                    <div className="get-app-box">
                      <ul className="clearfix">
                        <li className="p-0 text-center">
                          <small className="p-0 m-0">Toll-Free</small>
                          <a
                            className="px-1 py-1 rounded"
                            style={{ backgroundColor: "#9E1B1E" }}
                          >
                            <div className="icon">
                              <img
                                src={Phone}
                                width={25}
                                className="style2 text"
                                alt=""
                              />
                            </div>
                            <div className="text px-2">
                              <h4 className="text-white">8002</h4>
                            </div>
                          </a>
                        </li>
                        <li>
                          <div
                            className="d-flex gap-4"
                            style={{ marginTop: "30px" }}
                          >
                            <p>
                              <AiOutlinePhone size={19} className="mx-1 mb-1" />
                              +260 2113 89900
                            </p>
                            <p>
                              <BsWhatsapp size={19} className="me-1 mb-1" />
                              +260 7717 98616
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div style={{ marginRight: "35px", marginLeft: "35px" }}>
                  <a href="https://play.google.com/store/apps/details?id=com.izb.mobile" className="search-toggler" target="_blank">
                    <img src={PlayStore} />
                  </a>
                  <a href="https://apps.apple.com/in/app/izb-mobile-banking/id6754076496" className="search-toggler" target="_blank">
                    <img src={apple} />
                  </a>
                </div>
              </div>
         
            </div>
          </div>
        </div>
        {/*End Main Header Style1 Top*/}
        <nav className="main-menu main-menu-style1">
          <div className="main-menu__wrapper clearfix">
            <div className="container">
              <div className="main-menu__wrapper-inner w-100">
                <div className="main-menu-style1-left w-100">
                  <div className="main-menu-box w-100">
                    <div className="mobile-nav__toggler w-100">
                    <div className="mobile-nav__toggler1" onClick={toggleMenu}>
                          <GiHamburgerMenu />
                      </div>
                      <Link to="/">
                      <img src={Logo} width={270} className="ps-3" />
                      </Link>
                      <img src={notification} width={35} className="ps-3" />
                      </div>
                    <ul
                      className="main-menu__list justify-content-between"
                      style={{ gap: "2px" }}
                    >
                      <li className="megamenu ">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="dropdown">
                        <Link to="/AboutUs">
                          About <AiFillCaretDown size={10} className="ms-1" />
                        </Link>
                        <ul>
                          <li>
                            <Link to="/AboutUs">About IZB</Link>
                          </li>
                          <li>
                            <Link to="/BoardOfDirectors">
                              Leadership & Governance
                            </Link>
                            <ul>
                              <li>
                                <Link to="/BoardOfDirectors">
                                  Board Of Directors
                                </Link>
                              </li>
                              <li>
                                <Link to="/ExecutiveManagement">
                                  Executive Management
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <Link to="/FinancialPerformance">
                              Financial Performance
                            </Link>
                          </li>
                          <li>
                            <Link to="/WhyBankWithUs">Why Bank with us</Link>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <Link to="/PersonalBanking">
                          Personal Banking{" "}
                          <AiFillCaretDown size={10} className="ms-1" />
                        </Link>
                        <ul>
                          <li className="dropdown">
                            <a href="#">Saving Accounts</a>
                            <ul>
                              <li>
                                <Link to="/SavePlusAccount">
                                  Save Plus Bank A/C
                                </Link>
                              </li>
                              <li>
                                <Link to="/ClassicSavingAcc">
                                  Classic Saving Account
                                </Link>
                              </li>
                              <li>
                                <Link to="/PrivilageSavingAcc">
                                  Privilege Savings Account
                                </Link>
                              </li>
                              <li>
                                <Link to="/TisungoSaving">
                                  Tisunge Savings Account
                                </Link>
                              </li>
                              <li>
                                <Link to="/TonseSavingAcc">
                                  Tonse Savings Account
                                </Link>
                              </li>
                              <li>
                                <Link to="/SalaryAccount">
                                  Salary Account
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <Link to="/PremierBanking">
                            Premier Banking
                            </Link>
                          </li>
                          <li>
                            <a href="#">Credit</a>

                            <ul>
                              <li>
                                <Link to="/IndoHomeLoan">Indo Home Loan</Link>
                              </li>
                              <li>
                                <Link to="/IndoPersonalLoan">
                                  Personal Loan
                                </Link>
                              </li>
                              <li>
                                <Link to="/IndoVehicleLoan">
                                  Indo Vehicle Loan
                                </Link>
                              </li>
                              <li>
                                <Link to="/IndoGreenAssetFinanceScheme">
                                  Indo Green Asset Finance
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <Link to="/BumiFixedDepositAccount">
                              Bumi Fixed Deposit A/C
                            </Link>
                          </li>
                          <li>
                            <Link to="/IndoFastServe">Indo Fast Serve</Link>
                          </li>
                        </ul>
                      </li>

                      <li className="dropdown">
                        <Link to="/BusinessBanking">
                          Business Banking{" "}
                          <AiFillCaretDown size={10} className="ms-1" />
                        </Link>
                        <ul>
                          <li>
                            <a href="#">Current Account</a>
                            <ul>
                              <li>
                                <Link to="/PrivilegeCurrentAcc">
                                  Privilege Current Account
                                </Link>
                              </li>

                              <li>
                                <Link to="/ClassicCurrentAccount">
                                  Classic Current Account
                                </Link>
                              </li>

                              <li>
                                <Link to="/SMECurrentAcc">
                                  SME Current Account
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <a href="#">Credit</a>

                            <ul>
                              <li>
                                <Link to="/MSMELoan">MSME Loan</Link>
                              </li>

                              <li>
                                <Link to="/TermLoan">Term Loan</Link>
                              </li>
                               <li>
                                <Link to="/IndoVehicleFinance">Indo Vehicle Finance</Link>
                              </li>

                              <li>
                                <Link to="/AgroFinance">Agro Finance</Link>
                              </li>

                              <li>
                                <Link to="/IndoDairyDevelopmentScheme" style={{textAlign: "left"}}>Indo Dairy Development Scheme</Link>
                              </li>
                              <li>
                                <Link to="/IndoDairyProductionScheme" style={{textAlign: "left"}}>Indo Dairy Production Scheme</Link>
                              </li>

                              <li>
                                <Link to="/EquityRelease">Equity Release</Link>
                              </li>
                              <li>
                                <Link to="/BusinessFinance">Business Loan</Link>
                              </li>
                              <li>
                                <Link to="/WorkingCapitalFinance">
                                  Working Capital Finance
                                </Link>
                              </li>
                              <li>
                                <Link to="/LeaseRentalDiscounting">
                                  Lease Rental Discounting
                                </Link>
                              </li>
                              <li>
                                <Link to="/IndoGreenAssetFinanceScheme">
                                  Indo Green Asset Finance
                                </Link>
                              </li>
                              <li>
                                <Link to="/IndoKaSumfinLoan">
                                  Indo Ka Sumfin Loan
                                </Link>
                              </li>
                              <li>
                                <Link to="/IndoWomenPowerLoan">
                                  Indo Women Power Loan
                                </Link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <Link to="#">
                          {" "}
                          Forex & Treasury{" "}
                          <AiFillCaretDown size={10} className="ms-1" />
                        </Link>
                        <ul>
                          <li>
                            <a href="/ForexRates">Forex Rates</a>
                          </li>
                          <li>
                            <Link to="/InternationalBankingForeignBusiness">
                              Forex Business
                            </Link>
                          </li>
                          <li>
                            <Link to="/ForexSavings">Forex Savings</Link>
                          </li>
                          <li>
                            <Link to="/ForexCurrent">Forex Current</Link>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown">
                        <a href="#">
                          E-Services{" "}
                          <AiFillCaretDown size={10} className="ms-1" />
                        </a>
                        <ul>
                          <li>
                            <Link to="/MobileBanking">Indo NXT Mobile Banking </Link>
                          </li>
                          <li>
                            <Link to="/NetBanking">Indo NXT Corporate Banking</Link>
                          </li>
                          <li>
                            <Link to="/ContactlessCard">IZB Cards</Link>
                          </li>
                          <li>
                            <a href="https://epay.izb.co.zm/login/">
                              ZRA/NAPSA/E-Payment
                            </a>
                          </li>
                          <li>
                            <Link to="/EEZY">Indo EEZY</Link>
                          </li>
                          <li>
                            <Link to="/WalletBanking">Indo Wallet Banking</Link>
                          </li>
                        </ul>
                      </li>

                      <li className="dropdown">
                        <Link to="">
                            Insurance{" "}
                          <AiFillCaretDown size={10} className="ms-1" />
                        </Link>
                        <ul>
                          <li>
                            <a href="">General Insurance</a>
                            <ul className="right-dropdown-sub-menu-1">
                              <li>
                                <Link to="/HouseholdContentsInsurance">
                                    Household Contents Insurance
                                </Link>
                              </li>

                              <li>
                                <Link to="/HouseownersInsurance">
                                  Houseowners Insurance
                                </Link>
                              </li>

                              <li>
                                <Link to="/SmartDevices">
                                  Smart Devices
                                </Link>
                              </li>

                              <li>
                                <Link to="/PrivateMotorComprehensiveInsurance">
                                  Private Motor Comprehensive Insurance
                                </Link>
                              </li>

                              <li>
                                <Link to="/CommercialMotorComprehensiveInsurance">
                                  Commercial Motor Comprehensive Insurance
                                </Link>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <a href="">Life Assurance</a>
                            <ul className="right-dropdown-sub-menu-2">
                              <li>
                                <Link to="/IZBSmartChildEducationPlan">IZB Smart Child Education Plan</Link>
                              </li>
                              <li>
                                <Link to="/IZBFlexiFarewellFuneralPlan">Flexi Farewell Funeral Plan
                                </Link>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>

                    <img src={notification} width={30} />

                      <li className="dropdown last-main-button">
                        <a
                          href="#"
                          className="text-white rounded"
                          style={{ backgroundColor: "#9E1B1E" }}
                        >
                          IZB NXT Banking
                        </a>
                        <ul>
                          <li>
                            <a href="https://netbanking.izb.co.zm/ReachInet/IZB-web/inet/index.html" target="_blank">
                              Retail / Corporate
                            </a>
                          </li>
                          <li>
                          <Link to="/Tutorials">
                              Tutorials
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>

        <div className={`mobile-nav__wrapper ${menuOpen ? "expanded" : ""}`}>
       
          <div className="mobile-nav__overlay mobile-nav__toggler" />
          
          <div className="mobile-nav__content">
            <span className="mobile-nav__close mobile-nav__toggler">
              <i className="fas fa-plus" onClick={closeMenu}  />
            </span>
            <div className="logo-box">
              <Link to="/" aria-label="logo image">
                <img src={Logo} width={200} alt="" />
              </Link>
              
            </div>

            <div style={{ textAlign:"center" }}>
            <p   style={{ backgroundColor: "#FFF" }}>Download Mobile App</p>
              
                  <a href="https://play.google.com/store/apps/details?id=com.izb.mobile" className="search-toggler" target="_blank">
                    <img src={PlayStore}  style={{ marginTop:"0.5rem", marginBottom:"0.5rem" }}/>
                  </a>
                  <a href="https://apps.apple.com/in/app/izb-mobile-banking/id6754076496" className="search-toggler" target="_blank">
                    <img src={apple} style={{ marginTop:"0.5rem", marginBottom:"0.5rem" }}/>
                  </a>
                </div>
            <div className="mb-3 mx-0">
              <Sidebar>
                <Menu>
                  <MenuItem component={<Link to="/" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>Home</MenuItem>

                  <SubMenu label="About Us" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}>
                    <MenuItem component={<Link to="/AboutUs" />}  style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}  onClick={closeMenu}  >
                      About IZB
                    </MenuItem>

                    <SubMenu label="Leadership & Governance" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}>
                      <MenuItem component={<Link to="/BoardOfDirectors" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Board of Directors
                      </MenuItem>

                      <MenuItem component={<Link to="/ExecutiveManagement" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Executive Management
                      </MenuItem>
                    </SubMenu>

                    <MenuItem component={<Link to="/FinancialPerformance" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Financial Performance
                    </MenuItem>

                    <MenuItem component={<Link to="/WhyBankWithUs" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Why Bank with us
                    </MenuItem>
                  </SubMenu>

                  <SubMenu
                    label="Personal Banking"  style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}
                  >
                    <SubMenu label="Saving Accounts" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}>
                      <MenuItem component={<Link to="/SavePlusAccount" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Save Plus Bank A/C
                      </MenuItem>

                      <MenuItem component={<Link to="/ClassicSavingAcc" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Classic Saving Account
                      </MenuItem>

                      <MenuItem component={<Link to="/PrivilageSavingAcc" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Privilege Savings Account
                      </MenuItem>

                      <MenuItem component={<Link to="/TisungoSaving" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Tisunge Savings Account
                      </MenuItem>

                      <MenuItem component={<Link to="/TonseSavingAcc" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Tonse Savings Account
                      </MenuItem>

                      <MenuItem component={<Link to="/SalaryAccount" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Salary Account
                      </MenuItem>
                    </SubMenu>

                    <MenuItem
                      component={<Link to="/PremierBanking" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}
                    >
                      Premier Banking
                    </MenuItem>

                    <SubMenu label="Credit" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}>
                      <MenuItem component={<Link to="/IndoHomeLoan" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Indo Home Loan
                      </MenuItem>

                      <MenuItem component={<Link to="/IndoPersonalLoan" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Personal Loan
                      </MenuItem>

                      <MenuItem component={<Link to="/IndoVehicleLoan" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Indo Vehicle Loan
                      </MenuItem>

                      <MenuItem component={<Link to="/IndoGreenAssetFinanceScheme" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Indo Green Asset Finance
                      </MenuItem>
                    </SubMenu>

                    <MenuItem
                      component={<Link to="/BumiFixedDepositAccount" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}
                    >
                      Bumi Fixed Deposit A/C
                    </MenuItem>

                    <MenuItem component={<Link to="/IndoFastServe" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Indo Fast Serve
                    </MenuItem>
                  </SubMenu>

                  <SubMenu
                    label="Businesss Banking" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}
                  >
                    <SubMenu label="Current Account" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}>
                      <MenuItem component={<Link to="/PrivilegeCurrentAcc" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Privilege Current Account
                      </MenuItem>

                      <MenuItem
                        component={<Link to="/ClassicCurrentAccount" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}
                      >
                        Classic Current Account
                      </MenuItem>

                      <MenuItem component={<Link to="/SMECurrentAcc" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        SME Current Account
                      </MenuItem>
                    </SubMenu>

                    <SubMenu label="Credit" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}>
                      <MenuItem component={<Link to="/MSMELoan" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        MSME Loan
                      </MenuItem>

                      <MenuItem component={<Link to="/TermLoan" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Term Loan
                      </MenuItem>

                      <MenuItem component={<Link to="/AutoFinance" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Auto Finance
                      </MenuItem>
                    </SubMenu>

                    <MenuItem component={<Link to="/AgroFinance" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Agro Finance
                    </MenuItem>

                    <MenuItem component={<Link to="/IndoDairyDevelopmentScheme" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                     Indo Dairy Development Scheme
                    </MenuItem>

                    <MenuItem component={<Link to="/IndoDairyProductionScheme" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Indo Dairy Production Scheme
                    </MenuItem>

                    <MenuItem component={<Link to="/EquityRelease" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Equity Release
                    </MenuItem>

                    <MenuItem component={<Link to="/BusinessFinance" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Business Loan
                    </MenuItem>

                    <MenuItem component={<Link to="/WorkingCapitalFinance" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Working Capital Finance
                    </MenuItem>

                    <MenuItem component={<Link to="/LeaseRentalDiscounting" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Lease Rental Discounting
                    </MenuItem>

                    <MenuItem component={<Link to="/IndoGreenAssetFinanceScheme" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Indo Green Asset Finance
                    </MenuItem>

                    <MenuItem component={<Link to="/IndoKaSumfinLoan" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Indo Ka Sumfin Loan
                    </MenuItem>

                    <MenuItem component={<Link to="/IndoWomenPowerLoan" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Indo Women Power Loan
                    </MenuItem>
                  </SubMenu>

                  <SubMenu label="Forex & Treasury" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}>
                    <MenuItem component={<Link to="/ForexRates" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>Forex Rates</MenuItem>

                    <MenuItem
                      component={
                        <Link to="/InternationalBankingForeignBusiness" />
                      } style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}
                    >
                      Forex Business
                    </MenuItem>

                    <MenuItem component={<Link to="/ForexSavings" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Forex Savings
                    </MenuItem>

                    <MenuItem component={<Link to="/ForexCurrent" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Forex Current
                    </MenuItem>
                  </SubMenu>

                  <SubMenu label="E-Services" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}>
                    <MenuItem component={<Link to="/MobileBanking" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Indo NXT Mobile Banking 
                    </MenuItem>

                    <MenuItem component={<Link to="/NetBanking" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Indo NXT Corporate Banking
                    </MenuItem>

                    <MenuItem component={<Link to="/ContactlessCard" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      IZB Cards
                    </MenuItem>

                    <MenuItem
                      component={<a href="https://epay.izb.co.zm/login/" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}
                    >
                      ZRA/NAPSA/E-Payment
                    </MenuItem>
            
                    <MenuItem component={<Link to="/EEZY" />}  style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Indo EEZY
                    </MenuItem>
                    <MenuItem component={<Link to="/WalletBanking" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                      Indo Wallet Banking
                    </MenuItem>
                  </SubMenu>

                  <SubMenu
                    label="Insurance" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}
                  >
                    <SubMenu label="General Insurance" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}>
                      <MenuItem component={<Link to="/HouseholdContentsInsurance" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Household Contents Insurance
                      </MenuItem>

                      <MenuItem
                        component={<Link to="/HouseownersInsurance" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}
                      >
                        Houseowners Insurance
                      </MenuItem>

                      <MenuItem component={<Link to="/SmartDevices" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Smart Devices
                      </MenuItem>

                      <MenuItem component={<Link to="/PrivateMotorComprehensiveInsurance" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Private Motor Comprehensive Insurance
                      </MenuItem>

                      <MenuItem component={<Link to="/CommercialMotorComprehensiveInsurance" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Commercial Motor Comprehensive Insurance
                      </MenuItem>
                    </SubMenu>

                    <SubMenu label="Life Assurance" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}>
                      <MenuItem component={<Link to="/IZBSmartChildEducationPlan" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        IZB Smart Child Education Plan
                      </MenuItem>

                      <MenuItem component={<Link to="/IZBFlexiFarewellFuneralPlan" />} style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }} onClick={closeMenu}>
                        Flexi Farewell Funeral Plan
                      </MenuItem>
                    </SubMenu>
                  </SubMenu>

                  <SubMenu label="Indo NXT Banking" style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}>
                    <MenuItem
                      component={
                        <a href="https://netbanking.izb.co.zm/ReachInet/IZB-web/inet/index.html" target="_blank" />
                      }  style={{ backgroundColor: "#FFF5E7", borderBottom: "2px solid #DFC0C0" }}
                    >
                      Retail / Corporate
                    </MenuItem>
                  </SubMenu>

                </Menu>
              </Sidebar>
            </div>

            <div className="mobile-nav__social">
              <a
                href="https://mobile.twitter.com/IndoZambiaBank"
                className="fab fa-twitter"
              />
              <a
                href="https://www.facebook.com/IndoZambiaBank?_rdc=1&_rdr#"
                className="fab fa-facebook-square"
              />
              <a
                href="https://www.linkedin.com/company/indo-zambia-bank/"
                className="fab fa-linkedin"
              />
              <a
                href="https://www.instagram.com/indo_zambia_bank/"
                className="fab fa-instagram"
              />
            </div>
          </div>
        </div>
       

        {/*End Main Header Style1 Bottom*/}
      </header>
    </>
  );
};

export default Navbar;
